import { Euler as o } from "three";
const e = (t) => new o().setFromRotationMatrix(t).toArray().slice(0, 3);
export {
  e as MatrixToRotationV3
};
//# sourceMappingURL=index21.js.map
